// Packages Selectors
import get from 'lodash-es/get';

/**
 * Get the sum of all selected packages an its quantities.
 * @param {Object} state Packages store
 * @return {number} Net total
 */
export const getPackagesNetTotal = state => {
  const { selectedPackages } = state;
  const packagesNetTotal = selectedPackages.reduce((acc, selectedPackage) => {
    const { total, quantity, isAdjustment } = selectedPackage;
    return !isAdjustment ? total * parseInt(quantity) + acc : acc;
  }, 0);

  return packagesNetTotal;
};

/**
 * Get the sum of all selected packages taxes.
 * @param {Object} state Packages store
 * @return {number} All packages taxes
 */
export const getPackagesTaxes = state => {
  const { selectedPackages } = state;

  return selectedPackages.reduce((acc, selectedPackage) => {
    const { tax, quantity, isAdjustment } = selectedPackage;
    return !isAdjustment ? tax * parseInt(quantity) + acc : acc;
  }, 0);
};

export const getPackagesGrossTotal = state => {
  const { selectedPackages } = state;

  if (!selectedPackages) return 0;

  const packagesGrossTotal = selectedPackages.reduce((acc, selectedPackage) => {
    const { amount, quantity, isAdjustment } = selectedPackage;
    return !isAdjustment ? amount * parseInt(quantity) + acc : acc;
  }, 0);

  return packagesGrossTotal;
};

/**
 * Returns packages availability list.
 * @param {Object} State Packages Store.
 * @return {array} List of availability packages.
 */
export const getPackages = state => get(state, 'packageAvailabilityList');

/**
 * Returns the Birthday packages availability list.
 * @param {Object} State Packages Store.
 * @return {array} List of availability packages.
 */
export const getPackagesByType = (state, packageType) => {
  const { packageAvailabilityList } = state;
  if (!packageAvailabilityList) return [];

  return packageAvailabilityList.filter(pck => pck.packageType?.includes(packageType));
};

/**
 * Returns cabanas availability list.
 * @param {Object} State Packages Store.
 * @return {array} List of availability cabanas.
 */
export const getCabanas = state => get(state, 'cabanasAvailabilityList');

/**
 * Returns packages availability list.
 * @param {Object} State Packages Store.
 * @return {boolean} True if it is loading.
 */
export const getIsLoading = state => get(state, 'isLoading');

export const getPlanPackages = state => get(state, 'planPackages');

/**
 * Returns packages availability list.
 * @param {Object} State Packages Store.
 * @return {boolean} True if request failed
 */
export const getRequestFailed = state => get(state, 'requestFailed');

/**
 * Returns selected packages list.
 * @param {Object} State Packages Store.
 * @return {array} List of availability packages.
 */
export const getSelectedPackages = state => get(state, 'selectedPackages');

export const getAddedCabanasv3 = ({ addApackage }) => {
  return Object.values(addApackage.addedPackages);
};
